module.exports = __webpack_public_path__ + "img/login1.d5a13ad1.png";